<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <rect ref="frame" id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" fill="white" />
      <clipPath id="clip-frame">
        <use xlink:href="#Frame"/>
      </clipPath>
    </svg>

    <SceneDialogue
      :ref="`dialogue`"
      :width="1"
      :styles='{padding: "0"}'
      :tx="0" :ty="0.5">
      <div id="HowTo">
        <div class="tuts-cnr">
          <div class="tut mobile">
            <h1 class="heading minion bold">Mobile</h1>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="697" height="374" viewBox="0 0 697 374">
              <rect id="MobileScreen" fill="transparent" x="82" y="30" width="480" height="315" />
              <defs>
                <clipPath id="MobileScreenClip">
                  <use id="MobileScreenClipper" xlink:href="#MobileScreen" />
                </clipPath>
              </defs>
              <image class="phone" width="697" height="374" :xlink:href="`${publicPath}scenes/how-to/mobile.png`" />
              <g clip-path="url(#MobileScreenClip)">
                <image class="thumb" x="87" y="35" width="470" height="309" :xlink:href="`${publicPath}scenes/how-to/preview.jpg`" />
              </g>
            </svg>
            <ul class="steps">
              <li v-for="(s,i) in mobileTut.steps" :key="i">{{s}}</li>
            </ul>
          </div>
          <div class="tut desktop">
            <h1 class="heading minion bold">Desktop</h1>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="590" height="533" viewBox="0 0 590 533">
              <image width="590" height="533" :xlink:href="`${publicPath}scenes/how-to/desktop.png`" />
              <image x="44" y="43" width="499" height="310" :xlink:href="`${publicPath}scenes/how-to/preview.jpg`" />
            </svg>
            <ul class="steps">
              <li v-for="(s,i) in desktopTut.steps" :key="i">{{s}}</li>
            </ul>
          </div>
        </div>
      </div>
    </SceneDialogue>
  </div>
</template>

<script>
import Template from "./Template.vue"

export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    desktopTut,
    mobileTut,
    partners,
  }),
  extends: Template,
  computed: {
    current() {
      return this.$store.state.current || this.$store.getters.slide(0).slug
    },
  },
  components: {
  }
}

const desktopTut = {
  steps: [
    "Use arrow keys to go forward / back",
    "Move cursor to reveal timeline",
    "Click on timeline to skip ahead",
  ]
}

const mobileTut = {
  steps: [
    "Tap screen to reveal navigation",
    "Swipe screen left / right to go back & forth",
    "Slide along timeline to skip around",
    "Use two fingers to zoom in & out",
  ]
}

const partners = [
  { name: "The Onward Project", file: "OnwardSlug.png" },
  { name: "Museum of Northern Arizona", file: "mnalogo-transparent.png" },
  { name: "EC Compass", file: "EC_Compass_TM.jpg" },
  { name: "Center of Southwest Studies", file: "CSWS_2color_copy.jpg" },
  { name: "Fowler Museum at UCLA", file: "FM@UCLA-Logo-Blue-Gray-Transparent.png" },
]
</script>

<style lang="scss">
#HowTo {
  background: white; min-height: 100%; text-align: center;
  display: flex; flex-flow: column; justify-content: center;
  -webkit-overflow-scrolling: touch;
  .tuts-cnr {
    display: grid; grid-template-columns: 1fr 1fr; margin-bottom: 2em;
    svg { width: 15em; height: auto; }
    .mobile {
      svg { overflow: visible; }
      #MobileScreenClipper { transform-origin: 348.5px 187px; animation: landscape-phone 2s ease both 1s; }
      .phone { transform-origin: 348.5px 187px; animation: landscape-phone 2s ease both 1s; }
      .thumb { transform-origin: 348.5px 187px; animation: landscape-thumb 2s ease both 1s; }
    }
    .tut {
      display: grid; grid-template-columns: 1fr; grid-template-rows: min-content 1fr min-content;
      justify-items: center; align-items: center; text-align: center;
      &.desktop { order: 1 }
      &.mobile { order: 2 }
      .heading { margin-bottom: 1em; text-transform: uppercase; font-size: 3.3em; } }
    ul.steps {
      list-style-type: none; padding: 2em 0 0;
      li { margin-bottom: 0.5em; font-size: 1.5em; font-style: italic; } }
  }
  .rad-button { font-size: 1.5em; line-height: 0.8em; }
  footer { margin-top: 4em; }
  .logos-cnr {
    display: block; justify-content: space-around; align-items: center;
    max-width: 800px; margin: 2em auto 2em;
    > * { max-height: 80px; max-width: 300px; vertical-align: middle; margin: 1em; }
  }
}

@keyframes landscape-phone {
  0% { transform: rotate(90deg) scale(0.8); }
  50% { transform: rotate(0deg) scale(1); }
  100% { transform: rotate(0deg) scale(1); }
}
@keyframes landscape-thumb {
  0% { transform: scale(0.72) translate(26px, -25px); }
  50% { transform: scale(0.72) translate(26px, -25px) rotate(-90deg); }
  100% { transform: scale(1) translate(0px, 0px) rotate(0deg); }
}

@media screen and (max-width: 480px) {
  #HowTo {
    .tuts-cnr {
      .tut { .heading { font-size: 2.5em; } }
      ul.steps {
        li { font-size: 1.4em; }
      }
    }
  }
}
</style>
